import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { FornecedorList } from './List';
import { FornecedorForm } from './Form';

export const Fornecedor: React.FC = () => {
  return (
    <Switch>
      <Route path="/fornecedores" component={FornecedorList} isPrivate exact />
      <Route path="/fornecedores/new" component={FornecedorForm} isPrivate />
      <Route
        path="/fornecedores/edit/:id"
        component={FornecedorForm}
        isPrivate
      />
    </Switch>
  );
};
